export const hybridPlatformMap = {
  twitch: 'twitch',
  zoom: 'zoom',
  'google meet': 'meet',
  youtube: 'youtube',
  'microsoft teams': 'teams',
  vimeo: 'vimeo',
  webex: 'webex',
  linkedin: 'linkedin',
  'microsoft teams bot': 'teams',
};

export const getGetHybridPlatformSlug = (
  hybridPlatform?: keyof typeof hybridPlatformMap
) => {
  if (!hybridPlatform) return undefined;
  return hybridPlatformMap[hybridPlatform] as keyof typeof PLATFORMS;
};

export const PLATFORMS = {
  all: {
    order: 0,
    title: 'All',
    slug: 'all',
    logo: '/images/all_platforms.svg',
    sandboxOnly: false,
  },
  hybrid: {
    logo: '/images/hybrid.svg',
    title: 'Hybrid',
    order: 8,
    slug: 'hybrid',
    sandboxOnly: false,
  },
  twitch: {
    logo: '/images/twitch-icon.svg',
    title: 'Twitch',
    order: 6,
    slug: 'twitch',
    sandboxOnly: false,
  },
  zoom: {
    logo: '/images/Zoom.svg',
    title: 'Zoom',
    order: 1,
    slug: 'zoom',
    sandboxOnly: false,
  },
  ipa: {
    logo: '/images/in_person.svg',
    title: 'In-person',
    order: 7,
    slug: 'ipa',
    sandboxOnly: false,
  },
  meet: {
    logo: '/images/meet-icon.svg',
    title: 'Google Meet',
    order: 2,
    slug: 'meet',
    sandboxOnly: false,
  },
  youtube: {
    logo: '/images/youtube-icon.svg',
    title: 'YouTube',
    order: 3,
    slug: 'youtube',
    sandboxOnly: false,
  },
  teams: {
    logo: '/images/teams-logo.svg',
    title: 'Microsoft Teams',
    order: 4,
    slug: 'teams',
    sandboxOnly: false,
    hidden: true,
  },
  teams_web_bot: {
    logo: '/images/teams-logo.svg',
    title: 'Microsoft Teams Bot',
    order: 5,
    slug: 'teams_web_bot',
    sandboxOnly: false,
    hidden: true,
  },
  vimeo: {
    logo: '/images/vimeo-icon.svg',
    title: 'Vimeo',
    order: 6,
    slug: 'vimeo',
    sandboxOnly: false,
  },
  webex: {
    logo: '/images/webex-icon.svg',
    title: 'Webex',
    order: 7,
    slug: 'webex',
    sandboxOnly: false,
  },
  'other-online-events': {
    logo: '/images/OtherOnlinePlatforms.svg',
    title: 'Other online platforms',
    order: 8,
    slug: 'other-online-events',
    sandboxOnly: false,
  },
  linkedin: {
    logo: '/images/linkedin-icon.svg',
    title: 'LinkedIn',
    order: 9,
    slug: 'linkedin',
    sandboxOnly: true,
  },
  streamyard: {
    logo: '/images/streamyard.png',
    title: 'Streamyard',
    order: 10,
    slug: 'streamyard',
    sandboxOnly: true,
  },
  restream: {
    logo: '/images/restream.svg',
    title: 'Restream',
    order: 11,
    slug: 'restream',
    sandboxOnly: true,
  },
  airmeet: {
    logo: '/images/airmeet.svg',
    title: 'Airmeet',
    order: 12,
    slug: 'airmeet',
    sandboxOnly: true,
  },
  kick: {
    logo: '/images/kick.png',
    title: 'Kick',
    order: 13,
    slug: 'kick',
    sandboxOnly: true,
  },
  adobe_connect: {
    logo: '/images/adobe-connect-logo.svg',
    title: 'Adobe Connect',
    order: 14,
    slug: 'adobe_connect',
    sandboxOnly: true,
  },
};

export const PLATFORM_DISPLAY_NAME_TO_KEY: Record<string, string> = {
  'In-person': 'ipa',
  Hybrid: 'hybrid',
  Zoom: 'zoom',
  'Google Meet': 'meet',
  'Microsoft Teams': 'teams',
  'Microsoft Teams Bot': 'teams_web_bot',
  YouTube: 'youtube',
  Twitch: 'twitch',
  Vimeo: 'vimeo',
  Webex: 'webex',
  'Other online platforms': 'other-online-events',
  LinkedIn: 'linkedin',
  Restream: 'restream',
  Streamyard: 'streamyard',
  Airmeet: 'airmeet',
  Kick: 'kick',
  'Adobe Connect': 'adobe_connect'
};

export const PLATFORM_KEY_TO_DISPLAY_NAME: Record<string, string> = Object.fromEntries(
  Object.entries(PLATFORM_DISPLAY_NAME_TO_KEY).map(([display, key]) => [key, display])
);

export const PLATFORM_IMAGES = [
  {
    name: 'Zoom',
    icon: '/images/social-icons/zoom.svg'
  },
  {
    name: 'Microsoft Teams',
    icon: '/images/social-icons/teams.svg'
  },
  {
    name: 'Google Meet',
    icon: '/images/social-icons/meet.svg'
  },
  {
    name: 'Webex',
    icon: '/images/social-icons/webex.svg'
  },
  {
    name: 'YouTube Live',
    icon: '/images/social-icons/youtube.svg'
  },
  {
    name: 'Restream',
    icon: '/images/social-icons/restream.svg'
  }
];
